export const acquireApi = (agoraAppId) =>
  `https://api.agora.io/v1/apps/${agoraAppId}/cloud_recording/acquire`;

export const startApi = (agoraAppId, resourceId) => 
  `https://api.agora.io/v1/apps/${agoraAppId}/cloud_recording/resourceid/${resourceId}/mode/mix/start`;

export const stopApi = (agoraAppId, resourceId, sid) => 
  `https://api.agora.io/v1/apps/${agoraAppId}/cloud_recording/resourceid/${resourceId}/sid/${sid}/mode/mix/stop`;